<script lang="ts">
    export let label: string;
</script>

<div class="labeled-value-container">
    <span class="value-label">{label}</span>
    <span class="value"><slot/></span>
</div>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .labeled-value-container {
        display: flex;
        flex-direction: column;

        .value-label {
            font-size: @font-size-small;
            color: @themed-text-muted;
        }

        .value {
            font-weight: 500;
            font-size: @font-size-large;
        }
    }
</style>